import { FixedState } from '../types'
import { MutationTree } from 'vuex'
import setActiveSectionId from './setActiveSectionId'

const mutations: MutationTree<FixedState> = {
  setActiveSectionId,
}

export default mutations
